module.exports = __webpack_public_path__ + "img/room_img_error.6161b184.png";